import React, { Component } from "react";
import "./User.scss";
import MainLayout from "../../components/Layout/MainLayout";
import { LocalStore } from "../../utils/LocalStore";
import { Form, Input, Button, message } from "antd";
import { disconnectSocket } from "../../redux/actions/socket.action";
import { AxiosGetSecretApi, AxiosPostSecretApi } from "../../utils/fetchApi";
import { connect } from "react-redux";
import Card from "../../components/Card";
import { showMapLayer } from "../../redux/actions/menu.action";

class User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",

      // user info
      TenDangNhap: "",
      HoVaTen: "",
      TenPhongBan: "",
      Permistion: "",

      isLoading: false,

      isVisiableModalLogout: false,

      isEditPassword: false,
    };
    this.form = React.createRef();
    this.listTitle = ["Tên người dùng", "Họ và tên", "Quyền", "Phòng ban"];
    this.listValue = ["TenDangNhap", "HoVaTen", "Permistion", "TenPhongBan"];
    this.fakePass = [1, 2, 3, 4, 5, 6, 7, 8];
  }

  componentDidMount = async () => {
    this.getUserInfo();
    this.props.showMapLayer(false)
  };

  // user info
  async getUserInfo() {
    let id = LocalStore.getInstance().read("id");
    let res = await AxiosGetSecretApi(`/api/user/${id}/info`);
    if (res) {
      this.setState({
        TenDangNhap: res.TenDangNhap || "",
        HoVaTen: res.HoVaTen || "",
        TenPhongBan: res.TenPhongBan || "",
        Permistion: this.convertPermission(res.Permistion),
      });
    }
  }

  convertPermission(e) {
    let per = "";
    switch (e) {
      case "QuanTri":
        per = "Quản trị hệ thống";
        break;
      case "ChuyenVien":
        per = "Chuyên viên";
        break;
      case "LanhDao":
        per = "Lãnh đạo";
        break;
      case "Khac":
        per = "Khác";
        break;
      default:
        break;
    }
    return per;
  }
  //-----=====-----//

  onLogout = () => {
    LocalStore.getInstance().save("loginSession", null);
    LocalStore.getInstance().save("loginRole", null);
    LocalStore.getInstance().save("loginPermission", null);
    LocalStore.getInstance().save("loginListRole", null);
    LocalStore.getInstance().save("loginMaPhuongXa", null);
    localStorage.clear();
    this.props.history.push("/ttqh");
    this.props.disconnectSocket(true);
  };

  handleSubmit = async (e) => {
    this.setState({ isLoading: true });
    this.form.current
      .validateFields()
      .then((e) => {
        let data = {
          oldPassword: e.OldPassword,
          newPassword: e.NewPassword,
        };
        this.changePassword(data);
      })
      .catch(this.setState({ isLoading: false }));
  };

  async changePassword(data) {
    let id = LocalStore.getInstance().read("id");
    let res = await AxiosPostSecretApi(`/api/user/${id}/change-password`, data);
    if (res.success === false) {
      message.error(res.err);
    }
    if (res.success === true) {
      message.success("Đổi mật khẩu thành công");
      // save again new token
      LocalStore.getInstance().save("loginSession", res.token);
      setTimeout(() => {
        this.props.history.push("/");
      }, 500);
    }
    this.setState({ isLoading: false });
  }

  // modal logout

  showModalLogout = () => {
    this.setState({
      isVisiableModalLogout: true,
    });
  };

  cancelModalLogout = () => {
    this.setState({
      isVisiableModalLogout: false,
    });
  };

  editPassword = () => {
    this.setState({
      isEditPassword: true,
    });
  };

  render() {
    return (
      <MainLayout {...this.props} title={"Cài đặt tài khoản"}>
        <div className="page-with-card">
          <Card title="Cài đặt tài khoản">
            <div className="user">
              <div className="user-info">
                {this.listTitle.map((e, i) => (
                  <div className="row">
                    <div className="left-col">{e}:</div>
                    <div className="right-col right-col-border">
                      {this.state[`${this.listValue[i]}`]}
                    </div>
                  </div>
                ))}

                <div className="row">
                  <div className="left-col">Mật khẩu</div>
                  {!this.state.isEditPassword ? (
                    <div className="right-col right-col-border right-col-password">
                      <div style={{ display: "flex", alignItems: "center" }}>
                        {this.fakePass.map((e, i) => (
                          <i class="fas fa-circle fake-pass"></i>
                        ))}
                      </div>
                      <div>
                        <i
                          class="fas fa-pencil-alt icon-edit-password"
                          onClick={this.editPassword}
                        ></i>
                      </div>
                    </div>
                  ) : (
                    <div className="change-password">
                      <Form
                        onFinish={this.handleSubmit}
                        style={{ width: "400px" }}
                        layout="vertical"
                        ref={this.form}
                      >
                        <Form.Item
                          label="Mật khẩu cũ"
                          style={{ marginBottom: "20px" }}
                          hasFeedback
                          name="OldPassword"
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng nhập mật khẩu cũ",
                            },
                          ]}
                        >
                          <Input.Password
                            autoComplete="new-password"
                            className="input"
                          />
                        </Form.Item>

                        <Form.Item
                          label="Mật khẩu mới"
                          style={{ marginBottom: "20px" }}
                          hasFeedback
                          name="NewPassword"
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng nhập mật khẩu mới",
                            },
                            {
                              pattern: new RegExp(
                                "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$",
                                "g"
                              ),
                              message:
                                "Tối thiểu tám ký tự, ít nhất một chữ cái viết hoa, một chữ cái viết thường, một số và một ký tự đặc biệt",
                            },
                          ]}
                        >
                          <Input.Password
                            autoComplete="new-password"
                            className="input"
                          />
                        </Form.Item>

                        <Form.Item
                          name="confirm"
                          label="Xác nhận Mật khẩu"
                          style={{ marginBottom: "20px" }}
                          dependencies={["NewPassword"]}
                          hasFeedback
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng nhập lại mật khẩu",
                            },
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (
                                  !value ||
                                  getFieldValue("NewPassword") === value
                                ) {
                                  return Promise.resolve();
                                }
                                return Promise.reject(
                                  new Error("Mật khẩu không khớp")
                                );
                              },
                            }),
                          ]}
                        >
                          <Input.Password
                            autoComplete="new-password"
                            className="input"
                          />
                        </Form.Item>

                        <Form.Item>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginTop: "0px",
                            }}
                          >
                            <Button
                              type="danger"
                              loading={this.state.isLoading}
                              className="button-change-password font-size-16"
                              style={{ marginRight: "20px" }}
                              onClick={() => {
                                this.setState({ isEditPassword: false });
                              }}
                            >
                              Huỷ
                            </Button>

                            <Button
                              type="primary"
                              htmlType="submit"
                              loading={this.state.isLoading}
                              className="button-change-password font-size-16"
                            >
                              Cập nhật
                            </Button>
                          </div>
                        </Form.Item>
                      </Form>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Card>
        </div>
      </MainLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = {
  disconnectSocket: disconnectSocket,
  showMapLayer: showMapLayer
};

export default connect(mapStateToProps, mapDispatchToProps)(User);
